import React, { useCallback, useEffect, useState } from "react";
import {
    Row,
    Col,
    Input,
    Form,
    Button,
    message
} from "antd";
import { backendGetRequest } from "../../helpers/callBackend";
import { errorMessage } from "../../helpers/errorMessageFunc";

const GenerateCode = (props) => {
    const [verificationToken, setVerificationToken] = useState("");

    const getCode = async () => {
      // default to UN if no bank account source provided
      const bankAccountSource = props.bankAccountSource ? props.bankAccountSource : 'UN'
    
      if (bankAccountSource != 'UN') {
        // use twilio endpoint
        try {
          const otpResp = await backendGetRequest(
            '/api/payments/send-otp'
          )

          message.success(otpResp.data?.description)
        } catch (error) {
          errorMessage(`Error when trying to generate code: ${error}`)
        }
      } else {
        try{
          var verificationToken = await backendGetRequest(
          "/api/unit/verification-token/",
          { params: { bank_account_id: props.bankAccountId, entity_id: props.entityId } },
          "loading"
          );

          if (verificationToken.status == 200) {
            setVerificationToken(verificationToken?.data?.token);
            message.success("Text sent to your phone")
          } else {
            errorMessage("Error generating code for your payment request.")
          }


        } catch (error) {
          errorMessage(`Error when trying to generate code: ${error}`)
        }
      }

    };

    const handleChange = (e) => {
        var res = {
            'verificationCode': e.target.value,
            'verificationToken': verificationToken,
        }
        props.onChange(res);
    }
    
    return (
        <>
            <Row style={{ width: "100%" }}>
                <Col span={18}>
                    <Form.Item
                        label="Verification Code"
                        name="verificationCode"
                        rules={[
                            { required: true, message: "Please input the 6-digit code sent to your phone" },
                        ]}
                        onChange={handleChange}
                        style={{ marginRight: "20px" }}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Button 
                        type="primary" 
                        onClick={getCode} 
                        style={{ marginTop: "30px" }}
                    >
                        Generate Code
                    </Button>
                </Col>
            </Row>
        </>
    );
}

export default GenerateCode;